function parseCssDurationToMs(cssValue) {
  const value = cssValue.trim()
  if (!value) {
    return null
  }

  if (value.endsWith('ms')) {
    const parsedMs = Number.parseFloat(value)
    return Number.isNaN(parsedMs) ? null : parsedMs
  }

  if (value.endsWith('s')) {
    const parsedSeconds = Number.parseFloat(value)
    return Number.isNaN(parsedSeconds) ? null : parsedSeconds * 1000
  }

  return null
}

export { parseCssDurationToMs }
